import { generateTestId } from "@client-shared";

export const setSlaDetailModalTestId = (identifier: string): string =>
  generateTestId("SlaDetailModal", identifier);
